import { defineStore } from "pinia";
import { ref } from "vue";
export const useStore = defineStore("store", () => {
  const user_type = ref("");
  const user = ref({});
  const live_auction = ref(""); //THIS IS ONLY ID OF LIVE AUCTION - NOT FULL AUCTION OBJ
  //const live_pool = ref("");
  const bidding_team_id = ref("");
  const sale_action = ref(""); // to communicate to the PlayerControl component to show next player
  const action = ref("");
  const unsold_players = ref([]);
  const unsold_bids = ref([]);
  const max_bid = ref(0);
  const viewer_live_player_id = ref("");
  const viewer_expand_team_id = ref("");
  const viewer_modal_type = ref("");

  const setViewerExpandTeamId = (str, modal_type) => {
    viewer_expand_team_id.value = str;
    viewer_modal_type.value = modal_type; //team or player modal
  };
  const setViewerModalType = (modal_type) => {
    viewer_modal_type.value = modal_type;
  };
  const setViewerLivePlayerId = (str) => {
    viewer_live_player_id.value = str;
  };
  const setMaxBid = (max) => {
    max_bid.value = max;
  };
  const setAction = (str) => {
    if (action.value == str) {
      action.value = "";
    } else {
      action.value = str;
    }
  };
  const setUser = (u) => {
    user.value = u.user;
    user_type.value = u.user_type;
  };
  const clearData = () => {
    user_type.value = "";
    user.value = {};
    live_auction.value = "";
    action.value = "";
    bidding_team_id.value = "";
  };
  const setAuction = (id) => {
    if (live_auction.value == id) {
      live_auction.value = "";
    } else {
      live_auction.value = id;
    }
  };
  const clearAuction = () => {
    live_auction.value = "";
    bidding_team_id.value = "";
  };
  const setUserType = (str) => {
    user_type.value = str;
  };
  const setBiddingTeam = (str) => {
    bidding_team_id.value = str;
  };
  const saleAction = (str) => {
    sale_action.value = str;
  };
  const setUnsoldPlayers = (arr) => {
    unsold_players.value = arr;
  };
  const removeFromUnsold = (remove_id) => {
    unsold_players.value = unsold_players.value.filter(
      (player) => player.id !== remove_id
    );
  };
  const addToUnsold = (player) => {
    unsold_players.value.push(player);
  };
  const setUnsoldBids = (arr) => {
    unsold_bids.value = arr;
  };
  const addToUnsoldBids = (bid) => {
    unsold_bids.value.push(bid);
  };
  const removeFromUnsoldBids = (remove_id) => {
    unsold_bids.value = unsold_bids.value.filter((bid) => bid.id !== remove_id);
  };

  return {
    user_type,
    user,
    live_auction,
    // live_pool,
    bidding_team_id,
    sale_action,
    unsold_players,
    unsold_bids,
    action,
    max_bid,
    viewer_live_player_id,
    viewer_expand_team_id,
    viewer_modal_type,
    setViewerExpandTeamId,
    setViewerModalType,
    setViewerLivePlayerId,
    setMaxBid,
    setUser,
    clearData,
    setAction,
    setAuction,
    clearAuction,
    setUserType,
    setBiddingTeam,
    saleAction,
    setUnsoldPlayers,
    removeFromUnsold,
    addToUnsold,
    setUnsoldBids,
    addToUnsoldBids,
    removeFromUnsoldBids,
  };
});
